import { Controller } from "@hotwired/stimulus";
import { remove } from "lodash-es";
import { pushUnique } from "../../lib/helpers";

export default class extends Controller {
  static targets = ["suggestionSelector"];

  formController = null;
  states = {
    suggestionSelector: [],
    selectedSuggestionCalculateYear: [],
  };
  newlyAddedSuggestions = [];

  connect() {
    this.formController = this.application.getControllerForElementAndIdentifier(
      this.element,
      "form"
    );
  }

  suggestionSelectorTargetConnected(element) {
    if (element.dataset.forceOpen === "true") {
      element.open = true;
      return;
    }

    const componentId = Number(element.dataset.componentId);
    element.open = this.states.suggestionSelector.includes(componentId);
  }

  // The native toggle event is dispatched asynchronously, so a click landing
  // right before a Turbo re-render is lost when Stimulus unbinds the action.
  // Capturing the open state on disconnect keeps the re-rendered selector in
  // the state the user left it.
  suggestionSelectorTargetDisconnected(element) {
    if (element.dataset.forceOpen === "true") {
      return;
    }

    const componentId = Number(element.dataset.componentId);
    if (element.open) {
      pushUnique(this.states.suggestionSelector, componentId);
    } else {
      remove(this.states.suggestionSelector, (id) => id === componentId);
    }
  }

  toggleSuggestionSelector(event) {
    if (event.target.dataset.forceOpen === "true") {
      event.target.dataset.forceOpen = "false";
      return;
    }

    const componentId = Number(event.target?.dataset?.componentId);
    if (typeof componentId !== "number") {
      return;
    }

    if (event.target.open) {
      pushUnique(this.states.suggestionSelector, componentId);
    } else {
      remove(this.states.suggestionSelector, (id) => id === componentId);
    }
  }

  selectSuggestion({ params }) {
    const suggestionId = Number(params.suggestionId);
    const facilityComponentId = Number(params.facilityComponentId);
    const formData = new FormData(this.element);
    formData.append("selected_suggestion_ids[]", suggestionId);
    formData.append("selected_facility_component_ids[]", facilityComponentId);

    this.newlyAddedSuggestions.push(`${suggestionId}-${facilityComponentId}`);

    this.form.submit(formData);
  }

  get form() {
    if (!this.formController) {
      throw new Error("Form controller not found");
    }
    return this.formController;
  }
}
